export default "__VITE_ASSET__3ayuat7h__"